import { store } from '@betacrew/jars-flux'
import { PAGE_STATE } from '../../../constants/constants';

export const componentKey = "FORMS/REVIEW_APPROVE_FORMS/1099_FORMS";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },

        setStatusList: (state, action) => {
            state.statusList = action.payload;
        },

        setSelectedStatus: (state, action) => {
            state.selectedStatus = action.payload;
        },

        setFormsList: (state, action) => {
            state.formsList = action.payload;
        },

        setSelectedForm: (state, action) => {
            state.selectedForm = action.payload;
        },

        setTaxYears: (state, action) => {
            state.taxYears = action.payload;
        },

        setSelectedTaxYear: (state, action) => {
            state.selectedTaxYear = action.payload;
        },

        setPayersList: (state, action) => {
            state.payersList = action.payload;
        },

        setSelectedPayer: (state, action) => {
            state.selectedPayer = action.payload;
        },

        set1099FormsGrid: (state, action) => {
            state.$1099FormsGrid = action.payload;
        },

        setSelected1099FormsGrid: (state, action) => {
            state.selected1099Forms = action.payload;
        },

        setPaginationState: (state, action) => {
            state.paginationState = { ...state.paginationState, ...action.payload }
        },

        setDownloadAllPDFModal: (state, action) => {
            state.downloadAllPDFModal = action.payload;
        },

        setApproveFormsModal: (state, action) => {
            state.approveFormsModal = action.payload;
        },

        setRejectFormsModal: (state, action) => {
            state.rejectFormsModal = action.payload;
        },

        setRejectFormRemark: (state, action) => {
            state.rejectFormRemark = action.payload;
        },

        setMergePdfCheckbox: (state, action) => {
            state.mergePdfCheckbox = action.payload;
        },

        setPayerDropdownPagination: (state, action) => {
            state.payerDropdownPagination = { ...state.payerDropdownPagination, ...action.payload }
        },
    },
    initialReducerState: {
        loadingState: { state: PAGE_STATE.PAGE_READY, message: "" },

        //Filters
        statusList: [],
        selectedStatus: { label: "", value: "" },

        formsList: [],
        selectedForm: { label: "", value: "" },

        taxYears: [],
        selectedTaxYear: { label: "", value: "" },

        payersList: [],
        selectedPayer: { label: "", value: "" },

        //Grid
        $1099FormsGrid: [],
        selected1099Forms: [],

        paginationState: {
            PageNumber: 1,
            PageSize: 10,
            SearchByTIN: "",
            SearchByName: "",
            IsDesc: true,
            Skip: 0,
            total: 10,
        },

        payerDropdownPagination: {
            PageNumber: 1,
            PageSize: 10,
        },

        rejectFormRemark: "",
        mergePdfCheckbox: false,

        //Modals
        downloadAllPDFModal: false,
        approveFormsModal: false,
        rejectFormsModal: false,
    }
})

export const { setLoadingState, setStatusList, setSelectedStatus,
    setFormsList, setSelectedForm, setTaxYears, setSelectedTaxYear, setPayersList,
    setSelectedPayer, set1099FormsGrid, setSelected1099FormsGrid, setPaginationState, setDownloadAllPDFModal, setApproveFormsModal, setRejectFormsModal, setRejectFormRemark, setMergePdfCheckbox, setPayerDropdownPagination } = actions; 